// ─────────────────────────────────────────────────────────────────────────────
// GENERATED FILE — DO NOT EDIT HERE.
//
// Source of truth: invits-app-new/shared/mapEmbed.js
// Regenerate:     npm run sync:shared   (from invits-app-new)
//
// Editing this copy reintroduces exactly the app/web divergence that shared/
// exists to eliminate. Change the source, then re-run the sync.
// ─────────────────────────────────────────────────────────────────────────────

// shared/mapEmbed.js
//
// The embedded map for an invitation's venue: Google Maps, in an iframe.
//
// ── Why Google's embed, not Leaflet + OpenStreetMap ────────────────────────
//
// The Maps Embed API is free and unmetered - no billing per load - and it is
// the map people recognise, with Google's own labels and pins. The Leaflet
// version pulled a library from unpkg on every open, drew OSM tiles with the
// attribution the OSM licence requires switched off, and in the app it was a
// full Leaflet page inside a WebView inside a blurred card, which is what
// flashed black while scrolling.
//
// ── Key ────────────────────────────────────────────────────────────────────
//
// With a key, the documented Embed API. Without one (a build where the key was
// not configured), the keyless maps.google.com embed, so a missing key costs a
// setting, not the map. The key is safe to ship in a client: the Embed API has
// no quota to burn. Restrict it to the Maps Embed API and the invits.co
// referrer; the app loads its map with invits.co as the page's base URL for
// exactly that reason.

/**
 * @param {{ key?: string|null, placeId?: string|null, lat?: number|string|null, lng?: number|string|null, name?: string|null, zoom?: number }} p
 * @returns {string|null}
 */
export function mapEmbedUrl({ key, placeId, lat, lng, name, zoom = 15 } = {}) {
  const hasCoords = lat != null && lng != null && lat !== '' && lng !== ''
    && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));
  const coords = hasCoords ? `${Number(lat)},${Number(lng)}` : null;

  if (key) {
    const q = placeId ? `place_id:${placeId}` : coords || (name && String(name).trim()) || null;
    if (!q) return null;
    return `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(key)}`
      + `&q=${encodeURIComponent(q)}&zoom=${zoom}`;
  }

  const q = coords || (name && String(name).trim()) || null;
  if (!q) return null;
  return `https://maps.google.com/maps?q=${encodeURIComponent(q)}&z=${zoom}&output=embed`;
}
